import { render } from "./SingleCase.vue?vue&type=template&id=1aaae274"
import script from "./SingleCase.vue?vue&type=script&lang=js"
export * from "./SingleCase.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__